package com.crowpay.views.screens.contractor

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.views.components.nav.viewIsWide
import com.crowpay.views.components.space
import com.crowpay.views.theming.*
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*

interface PaymentScreen

@Routable("/contractor/payments")
class ContractorPayments() : ContractorPage, PaymentScreen, ContractorPaymentInfo() {

    override val title: Readable<String> = Constant("Payments")

    override fun ViewWriter.renderMainContent() {

        scrolls - col {
            spacing = 0.dp

            title("Finances")

            space(AppDimensions.backgroundIndent)

            subTitle("Here’s your financial snapshot: each project draw or release is broken down into gross value, CrowPay’s small fee, and the net amount you can collect right now. Simply hit Collect Funds, choose where you want your money, and we’ll handle the rest. Your full payout history lives below.")

            space(AppDimensions.backgroundIndent)

            sizeConstraints(maxWidth = 16.rem) - availableFundsCard()

            space(AppDimensions.backgroundIndent)

            if (viewIsWide) rowCollapsingToColumn(AppDimensions.pageWidth * 2) {
                expanding - newAvailableFundsTable()
                expanding - transferHistoryTable(true)
            }
        }
    }
}